import {
  FILTERS_BY_GROUPS_IDS as sharedFiltersByGroupsIds,
  FILTERS_GROUPS as sharedFiltersGroups,
  FILTERS_GROUPS_IDS as sharedFiltersGroupsIds
} from '../../common/filtersGroups.js'
import {LISTING_SECTION_IDS} from '../../common/listingSections.js'
import {ALL_VEHICLES_LISTING_SECTION_FILTERS_GROUPS} from './allVehiclesListingSectionFiltersGroups.js'
import {BUGGIES_NEW_VEHICLES_LISTING_SECTION_FILTERS_GROUPS} from './buggiesNewVehiclesListingSectionFiltersGroups.js'
import {BUGGIES_SECOND_HAND_VEHICLES_LISTING_SECTION_FILTERS_GROUPS} from './buggiesSecondHandVehiclesListingSectionFiltersGroups.js'
import {BUGGIES_VEHICLES_LISTING_SECTION_FILTERS_GROUPS} from './buggiesVehiclesListingSectionFiltersGroups.js'
import {CLASSIC_MOTOS_VEHICLES_LISTING_SECTION_FILTERS_GROUPS} from './classicMotosVehiclesListingSectionFiltersGroups.js'
import {MINIMOTOS_NEW_VEHICLES_LISTING_SECTION_FILTERS_GROUPS} from './minimotosNewVehiclesListingSectionFiltersGroups.js'
import {MINIMOTOS_SECOND_HAND_VEHICLES_LISTING_SECTION_FILTERS_GROUPS} from './minimotosSecondHandVehiclesListingSectionFiltersGroups.js'
import {MINIMOTOS_VEHICLES_LISTING_SECTION_FILTERS_GROUPS} from './minimotosVehiclesListingSectionFiltersGroups.js'
import {NEW_VEHICLES_LISTING_SECTION_FILTERS_GROUPS} from './newVehiclesListingSectionFiltersGroups.js'
import {QUADS_AND_ATVS_NEW_VEHICLES_LISTING_SECTION_FILTERS_GROUPS} from './quadsAndAtvsNewVehiclesListingSectionFiltersGroups.js'
import {QUADS_AND_ATVS_SECOND_HAND_VEHICLES_LISTING_SECTION_FILTERS_GROUPS} from './quadsAndAtvsSecondHandVehiclesListingSectionFiltersGroups.js'
import {QUADS_AND_ATVS_VEHICLES_LISTING_SECTION_FILTERS_GROUPS} from './quadsAndAtvsVehiclesListingSectionFiltersGroups.js'
import {SECOND_HAND_VEHICLES_LISTING_SECTION_FILTERS_GROUPS} from './secondHandVehiclesListingSectionFiltersGroups.js'

export const FILTERS_GROUPS_BY_LISTING_SECTION_ID = {
  [String(LISTING_SECTION_IDS.ALL_VEHICLES)]: ALL_VEHICLES_LISTING_SECTION_FILTERS_GROUPS,
  [String(LISTING_SECTION_IDS.BUGGIES_VEHICLES)]: BUGGIES_VEHICLES_LISTING_SECTION_FILTERS_GROUPS,
  [String(LISTING_SECTION_IDS.BUGGIES_NEW_VEHICLES)]: BUGGIES_NEW_VEHICLES_LISTING_SECTION_FILTERS_GROUPS,
  [String(LISTING_SECTION_IDS.BUGGIES_SECOND_HAND_VEHICLES)]:
    BUGGIES_SECOND_HAND_VEHICLES_LISTING_SECTION_FILTERS_GROUPS,
  [String(LISTING_SECTION_IDS.CLASSIC_MOTOS_VEHICLES)]: CLASSIC_MOTOS_VEHICLES_LISTING_SECTION_FILTERS_GROUPS,
  [String(LISTING_SECTION_IDS.MINIMOTOS_NEW_VEHICLES)]: MINIMOTOS_NEW_VEHICLES_LISTING_SECTION_FILTERS_GROUPS,
  [String(LISTING_SECTION_IDS.MINIMOTOS_SECOND_HAND_VEHICLES)]:
    MINIMOTOS_SECOND_HAND_VEHICLES_LISTING_SECTION_FILTERS_GROUPS,
  [String(LISTING_SECTION_IDS.MINIMOTOS_VEHICLES)]: MINIMOTOS_VEHICLES_LISTING_SECTION_FILTERS_GROUPS,
  [String(LISTING_SECTION_IDS.NEW_VEHICLES)]: NEW_VEHICLES_LISTING_SECTION_FILTERS_GROUPS,
  [String(LISTING_SECTION_IDS.QUADS_AND_ATVS_NEW_VEHICLES)]: QUADS_AND_ATVS_NEW_VEHICLES_LISTING_SECTION_FILTERS_GROUPS,
  [String(LISTING_SECTION_IDS.QUADS_AND_ATVS_SECOND_HAND_VEHICLES)]:
    QUADS_AND_ATVS_SECOND_HAND_VEHICLES_LISTING_SECTION_FILTERS_GROUPS,
  [String(LISTING_SECTION_IDS.QUADS_AND_ATVS_VEHICLES)]: QUADS_AND_ATVS_VEHICLES_LISTING_SECTION_FILTERS_GROUPS,
  [String(LISTING_SECTION_IDS.SECOND_HAND_VEHICLES)]: SECOND_HAND_VEHICLES_LISTING_SECTION_FILTERS_GROUPS
}

// Define only the filters groups that are different from the common ones
export const FILTERS_GROUPS = {...sharedFiltersGroups}

// Do not redefine the filters groups ids that are already defined in the common ones
export const FILTERS_GROUPS_IDS = {...sharedFiltersGroupsIds}

// Define only the filters by groups ids that are different from the common ones
export const FILTERS_BY_GROUPS_IDS = {...sharedFiltersByGroupsIds}
